// src/components/SvgFilterDefinitions.tsx
import React from "react";

export function SvgFilterDefinitions() {
  // Styles to hide the SVG container
  const svgStyle: React.CSSProperties = {
    // visibility: "hidden", // Use visibility: hidden as provided
    //zIndex: -1,
    position: "absolute",
    // width: 0,
    // height: 0,
  };

  return (
    <svg
      style={svgStyle}
      width="0"
      height="0"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      aria-hidden="true"
    >
      <defs>
        {/* Your Instagram-style filter */}
        <filter id="instagram">
          <feGaussianBlur
            in="SourceGraphic"
            stdDeviation="5" // Use camelCase for attributes in JSX
            result="blur"
          />
          <feColorMatrix
            in="blur"
            mode="matrix"
            values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 20 -8" // Keep string value as is
            result="goo"
          />
          <feComposite in="SourceGraphic" in2="goo" operator="atop" />
        </filter>

        {/* Add more filters here if needed */}
      </defs>
    </svg>
  );
}
